export const RECHARGE_API_URL = (environment: 'stage' | 'prod'): string =>
  environment === 'stage' ? 'https://api.stage.rechargeapps.com' : 'https://api.rechargeapps.com';
export const RECHARGE_ADMIN_URL = (environment: 'stage' | 'prod'): string =>
  environment === 'stage' ? 'https://admin.stage.rechargeapps.com' : 'https://admin.rechargeapps.com';
export const RECHARGE_CDN_URL = (environment: 'stage' | 'prod'): string =>
  environment === 'stage' ? 'https://static.stage.rechargecdn.com' : 'https://static.rechargecdn.com';
export const RECHARGE_HOSTED_DOMAIN = '.admin.rechargeapps.com';
export const SHOPIFY_EMBEDDED_DOMAIN = '.myshopify.com';
export const SHOPIFY_APP_PROXY_URL = '/tools/recurring';
